import React, { useEffect, useRef } from "react";
import BackArrow from "../common/BackArrow";
import { connect } from "react-redux";
import PolicyEditor from "./PolicyEditor";
import API from "../common/Api";

const mapStateToProps = (state) => ({
  headers: state.headers(),
  business: state.business,
});

export default connect(mapStateToProps)(function PolicySettings({ ...props }) {
  const [policyContent, setPolicyContent] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);
  const quillRef = useRef(null);
  const [isFocused, setIsFocused] = React.useState(false);

  useEffect(() => {
    setPolicyContent(props.business?.policy || "");
  }, [props.business]);

  const handleSave = async () => {
    setIsFocused(false);
    setIsLoading(true);

    const payload = {
      policy: `${policyContent}`,
    };
    try {
      const response = await API.put(`business/policy`, payload, {
        headers: props.headers,
      });

      if (response) {
        setIsLoading(false);
        window.$.notify("Booking policy saved successfully!", "success-alert");
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error saving policy:", error);
    }
  };

  const MAX_CHARS = 5000;

  const getCharCount = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html || "";
    // Remove all newlines (including Quill's trailing newline)
    return div.innerText.replace(/\n/g, "").length;
  };

  const charCount = getCharCount(policyContent);

  const handleEditorChange = (content) => {
    setPolicyContent(content);
  };

  useEffect(() => {
    if (!quillRef.current) return;
    const quill = quillRef.current.getEditor();

    const handleTextChange = (delta, oldDelta, source) => {
      // Only block if user is inserting
      const ops = delta.ops || [];
      const isInsert = ops.some((op) => typeof op.insert !== "undefined");
      if (!isInsert) return;

      // Get visible character count after change
      const html = quill.root.innerHTML;
      const visibleCount = getCharCount(html);

      if (visibleCount > MAX_CHARS) {
        quill.history.undo();
      }
    };

    quill.on("text-change", handleTextChange);

    return () => {
      quill.off("text-change", handleTextChange);
    };
  }, []);

  return (
    <div className="onboarding-page profile-settings-page">
      <h1 className="form-title dsk">Booking Policy</h1>
      <div className="form_step form-page">
        <h1 className="form-title mbl flex center">
          <BackArrow />
          Booking Policy
        </h1>
        <div className="form-container card policy-editor">
          {/* <PolicyEditor/> */}
          <p className="policy-editor-description">
            Show clear rules for deposits, cancellations, rescheduling and more
            so customers understand how your business works and what to expect
            before booking any services you offer.
          </p>

          <div className="policy-editor-container">
            <h3 className="policy-editor-title">Enter Booking Policy</h3>
            <div className="policy-editor-wrapper">
              <PolicyEditor
                value={policyContent}
                onChange={handleEditorChange}
                placeholder="Start by telling customers how your bookings work. e.g. deposit rules, cancellation windows, late arrival policy, and contact info if they have questions."
                ref={quillRef}
                isFocused={isFocused}
                setIsFocused={setIsFocused}
              />
            </div>
          </div>
          <div className="char-count">
            {charCount}/{MAX_CHARS}
          </div>
          <div className="policy-editor-actions">
            <button
              className={
                "policy-editor-save-btn" +
                (isLoading ? " disabled" : "") +
                (policyContent.trim() === "" ? " disabled" : "")
              }
              onClick={handleSave}
              disabled={isLoading || policyContent.trim() === ""}
            >
              {isLoading ? "Saving Changes..." : "Save Changes"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
});
